/**
 * defa.views.CustomerSnippet
 * A view for a single selectable Customer.
 * @version 1.2.2
 */
import Snippet from 'scripts/poppet/snippet';

const CustomerSnippet = Snippet.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	templateContext: function () {
		
		let superContext = Snippet.prototype.templateContext.call( this );
		
		return _.extend( superContext, {
			iconClass : this.getIconClasses(),
			header    : this.model.name(),
		} );
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Creates a string for icon classes.
	 * @void
	 */
	getIconClasses: function () {
		
		return 'icon icon-material icon-labelled icon-' + this.model.get( 'type' ).toLowerCase();
	},
	
} );

export default CustomerSnippet;
	